/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Information about the software version that is deployed
 */
export type BuildConfig = {
  /**
   * Branch name
   */
  branch: string;
  /**
   * Commit hash
   */
  commit: string;
  /**
   * UI branch being previewed (if any)
   */
  previewBranch?: string | undefined;
  /**
   * Why the UI branch cookie is set: discretionary, labs, labsOptOut, or a future value (passed through uninterpreted)
   */
  previewBranchMode?: string | undefined;
};

/** @internal */
export const BuildConfig$inboundSchema: z.ZodType<
  BuildConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  branch: types.string(),
  commit: types.string(),
  preview_branch: types.optional(types.string()),
  preview_branch_mode: types.optional(types.string()),
}).transform((v) => {
  return remap$(v, {
    "preview_branch": "previewBranch",
    "preview_branch_mode": "previewBranchMode",
  });
});
/** @internal */
export type BuildConfig$Outbound = {
  branch: string;
  commit: string;
  preview_branch?: string | undefined;
  preview_branch_mode?: string | undefined;
};

/** @internal */
export const BuildConfig$outboundSchema: z.ZodType<
  BuildConfig$Outbound,
  z.ZodTypeDef,
  BuildConfig
> = z.object({
  branch: z.string(),
  commit: z.string(),
  previewBranch: z.string().optional(),
  previewBranchMode: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    previewBranch: "preview_branch",
    previewBranchMode: "preview_branch_mode",
  });
});

export function buildConfigToJSON(buildConfig: BuildConfig): string {
  return JSON.stringify(BuildConfig$outboundSchema.parse(buildConfig));
}
export function buildConfigFromJSON(
  jsonString: string,
): SafeParseResult<BuildConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BuildConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BuildConfig' from JSON`,
  );
}
